import { render, staticRenderFns } from "./ChangeLanguage.vue?vue&type=template&id=5510d243&scoped=true&"
import script from "./ChangeLanguage.vue?vue&type=script&lang=ts&"
export * from "./ChangeLanguage.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeLanguage.vue?vue&type=style&index=0&id=5510d243&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5510d243",
  null
  
)

export default component.exports